import { Component, inject, Injector, OnInit, runInInjectionContext, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { StitchServiceFactory } from '@modules/common/factories/stitch-service.factory';
import { StitchTypeToEntityType } from '@modules/common/utils/stitch';
import { StateKey } from '@modules/settings/types/state-key';
import { StitchType } from '@sharedlib/common/types/StitchType';
import { map, Observable, switchMap } from 'rxjs';

@Component({
  template: '',
  standalone: true,
  styleUrls: ['./shared-base.component.less'],
})
export abstract class SharedBaseComponent<T extends StitchTypeToEntityType<StitchType>> implements OnInit {
  public readonly StateKey = StateKey;

  protected abstract readonly stitchType: StitchType;

  protected readonly route: ActivatedRoute = inject(ActivatedRoute);
  protected readonly injector: Injector = inject(Injector);
  protected readonly stitchServiceFactory: StitchServiceFactory = inject(StitchServiceFactory);

  protected stitchItem: Signal<T> | undefined;

  public ngOnInit(): void {
    runInInjectionContext(this.injector, () => {
      this.stitchItem = toSignal<T>(this.loadSharedItem());
    });
  }

  protected loadSharedItem(): Observable<T> {
    return this.route.params.pipe(
      map((params) => params['id']),
      switchMap(
        (id) => this.stitchServiceFactory.getServiceByStitchType(this.stitchType).getSharedItem(id) as Observable<T>,
      ),
    );
  }
}
